import { viewId, table, restApiKey } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { getDynamoDB, getDataCreateTask } from '../../../../common/utils/DynamoDbUtils'
import { httpPost } from '../../../../services/api/AmplifyApi'
import { getObject, readCsvFile } from '../../../../common/utils/FileUtils'

import '../extra/types'

const _getCsvData = async (bucketName, filePath, fileName) => {
  const fileData = await getObject(bucketName, filePath + fileName)
  const file = new File([fileData], fileName, { type: 'text/plain' })
  let list = await readCsvFile(file)
  // 最終行が空行の場合は削除する
  list = list.filter(
    (row, index) =>
      index !== list.length - 1 || !row.every((cell) => cell === '' || cell === null || cell === undefined)
  )
  return list
}

/**
 * マスター一覧テーブルを取得
 *
 * @param {String} corporationNumber 法人番号
 * @returns マスター一覧テーブル
 */
export async function fetchMaster(corporationNumber) {
  let master = await getDynamoDB(
    table.Master,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber, MasterId: viewId.employeeCountInfo },
    null
  )
  return master[0]
}

/**
 * データ作成タスク管理を取得
 *
 * @param {String} corporationNumber 法人番号
 * @param {String} searchKey 検索キー
 * @returns データ作成タスク管理
 */
export async function fetchtDataCreateTask(corporationNumber, searchKey) {
  let dataCreateTask = await getDataCreateTask(corporationNumber, searchKey)

  return dataCreateTask
}

/**
 * 指定されたS3バケットから雇用区分マスターのCSVデータを取得する関数
 *
 * @param {string} bucketName - データが格納されているS3バケット名
 * @returns {Promise<(string | number)[][]>} 雇用区分マスターが格納されたCSVデータの2次元配列を返す。
 *
 *   CSVデータの想定カラム： ["法人番号", "企業名", "雇用区分", "有効開始日", "有効終了日", "表示順"]
 */
export async function fetchEmploymentTypesInfo(bucketName) {
  const filePath = PathInfoList.Folder.employmentTypeFolder
  const fileName = PathInfoList.Objectkeyname.employmentType
  const csvData = await _getCsvData(bucketName, filePath, fileName)
  // const _csvData = [
  //   ['法人番号', '企業名', '雇用区分', '有効開始日', '有効終了日', '表示順'],
  //   ['1234567890123', 'A社', '取締役', '', '', 1]
  // ['1234567890123', 'A社', '執行役', '', '', 2],
  // ['1234567890123', 'A社', '正社員', '2024/12/30', '2025/01/01', 3],
  // ['1234567890123', 'A社', '一般職正社員', '2024/04/01', '', 4],
  // ['1234567890123', 'A社', '管理職正社員', '2024/04/01', '', 5],
  // ['1234567890123', 'A社', '執行役員', '', '', 6],
  // ['1234567890123', 'A社', '契約社員', '', '', 7],
  // ['1234567890123', 'A社', '嘱託', '', '', 8],
  // ['1234567890123', 'A社', 'アルバイト', '', '', 9],
  // ['1234567890123', 'A社', 'パートタイマー', '', '', 10],
  // ['1234567890123', 'A社', '派遣社員', '', '', 11],
  // ['1234567890123', 'A社', '業務委託', '', '', 12]
  // ]
  return csvData
}

/**
 * 指定されたS3バケットから雇用区分設定情報のCSVデータを取得する関数
 *
 * @param {string} bucketName - データが格納されているS3バケット名
 * @returns {Promise<(string | number)[][]>} 雇用区分設定情報が格納されたCSVデータの2次元配列を返す。
 *
 *   CSVデータの想定カラム： ["法人番号", "企業名", "年度", "決算年月", "雇用区分", "有報従業員区分", "FTE概算係数"]
 */
export async function fetchEmploymentTypeSetting(bucketName) {
  const filePath = PathInfoList.Folder.employmentTypeSettingFolder
  const fileName = PathInfoList.Objectkeyname.employmentTypeSetting
  const csvData = await _getCsvData(bucketName, filePath, fileName)
  // const _csvData = [
  //   [
  //     '法人番号',
  //     '企業名',
  //     '年度',
  //     '決算年月',
  //     '雇用区分',
  //     '有報従業員区分',
  //     'FTE概算係数'
  //   ],
  //   ['1234567890123', 'A社', '2024年度', '2024-03-31', '取締役', '対象外', '10'],
  //   ['1234567890123', 'A社', '2024年度', '2024-03-31', '一般職正社員', '従業員', '1']
  // ]
  return csvData
}

/**
 * 指定されたS3バケットから所定労働時間設定（月）のCSVデータを取得する関数
 *
 * @param {string} bucketName - データが格納されているS3バケット名
 * @returns {Promise<(string | number)[][]>} 所定労働時間設定（月）が格納されたCSVデータの2次元配列を返す。
 *
 *   CSVデータの想定カラム： ["法人番号", "企業名", "年度", "決算年月", "所定労働時間／日", "月", "営業日数", "所定労働時間／月"]
 */
export async function fetchPrescribedWorkingHoursMonth(bucketName) {
  const filePath = PathInfoList.Folder.prescribedWorkingHoursMonthFolder
  const fileName = PathInfoList.Objectkeyname.prescribedWorkingHoursMonth
  const csvData = await _getCsvData(bucketName, filePath, fileName)
  // const _csvData = [
  //   ['法人番号', '企業名', '年度', '決算年月', '所定労働時間／日', '月', '営業日数', '所定労働時間／月'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '4月', '20', '160'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '5月', '18', '144'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '6月', '21', '168'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '7月', '21', '168'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '8月', '22', '176'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '9月', '20', '160'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '10月', '20', '160'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '11月', '18', '144'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '12月', '21', '168'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '1月', '21', '168'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '2月', '18', '144'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '8', '3月', '22', '176']
  // ]
  return csvData
}

/**
 * 指定されたS3バケットから所定労働時間設定（年）のCSVデータを取得する関数
 *
 * @param {string} bucketName - データが格納されているS3バケット名
 * @returns {Promise<(string | number)[][]>} 所定労働時間設定（年）が格納されたCSVデータの2次元配列を返す。
 *
 *   CSVデータの想定カラム： ["法人番号", "企業名", "年度", "決算年月", "年間週数", "所定労働時間／週", "所定労働時間／年"]
 */
export async function fetchPrescribedWorkingHoursYear(bucketName) {
  const filePath = PathInfoList.Folder.prescribedWorkingHoursYearFolder
  const fileName = PathInfoList.Objectkeyname.prescribedWorkingHoursYear
  const csvData = await _getCsvData(bucketName, filePath, fileName)
  // const _csvData = [
  //   ['法人番号', '企業名', '年度', '決算年月', '年間週数', '所定労働時間／週', '所定労働時間／年'],
  //   ['1234567890123', 'A社', '2024年度', '2025-03-31', '52', '40', '2080']
  // ]
  return csvData
}

/**
 * 指定されたS3バケットから人数カウント設定情報のCSVデータを取得する関数
 *
 * @param {string} bucketName - データが格納されているS3バケット名
 * @returns {Promise<(string | number)[][]>} 人数カウント設定情報が格納されたCSVデータの2次元配列を返す。
 *
 *   CSVデータの想定カラム： ["法人番号", "企業名", "年度", "決算年月", "小数設定", "休職者_集計先", "グループ内出向_出向元", "グループ内出向_出向先", "グループ外出向_出向元",
 *   "グループ外出向_出向先", "兼務出向_集計先"]
 */
export async function fetchEmployeeCountSetting(bucketName) {
  const filePath = PathInfoList.Folder.employeeCountSettingFolder
  const fileName = PathInfoList.Objectkeyname.employeeCountSetting
  const csvData = await _getCsvData(bucketName, filePath, fileName)
  // const _csvData = [
  //   [
  //     '法人番号',
  //     '企業名',
  //     '年度',
  //     '決算年月',
  //     '小数設定',
  //     '休職者_集計先',
  //     'グループ内出向_出向元',
  //     'グループ内出向_出向先',
  //     'グループ外出向_出向元',
  //     'グループ外出向_出向先',
  //     '兼務出向_集計先'
  //   ],
  //   [
  //     '1234567890123',
  //     'A社',
  //     '2024年度',
  //     '2025-03-31',
  //     '切り捨て',
  //     '含めない',
  //     '含める',
  //     '含めない',
  //     '含める',
  //     '含めない',
  //     '本務'
  //   ],
  //   [
  //     '1234567890123',
  //     'A社',
  //     '2025年度',
  //     '2026-03-31',
  //     '四捨五入',
  //     '含める',
  //     '含めない',
  //     '含める',
  //     '含めない',
  //     '含める',
  //     '出向元'
  //   ]
  // ]
  return csvData
}

export async function updateEmployeeCount(corporationNumber, corporationName, accPeriod, userName, userSub, payload) {
  const requestPayload = {
    corporation_number: corporationNumber,
    corporation_name: corporationName,
    fiscal_month: accPeriod,
    user_name: userName,
    user_sub: userSub,
    file_data: payload
  }

  const init = {
    headers: {},
    body: requestPayload
  }

  return httpPost(restApiKey.CHROFY_REST_API, PathInfoList.Resource.updateEmployeeCount(corporationNumber), init)
}
